import React from "react";

const SwitchView = ({
  label = "",
  description = "",
  value = false,
  onChange,
  disabled = false,
  labelPosition = "left", // 'left' | 'right' | 'top'
  size = "md", // 'sm' | 'md' | 'lg'
  id,
  className = "",
  labelClassName = "",
}) => {
  const generatedId = React.useId();
  const switchId = id || generatedId;

  // Size configurations
  const sizes = {
    sm: {
      track: "w-8 h-4",
      thumb: "w-3 h-3",
      translate: "translate-x-4",
      text: "text-xs",
    },
    md: {
      track: "w-11 h-6",
      thumb: "w-5 h-5",
      translate: "translate-x-5",
      text: "text-sm",
    },
    lg: {
      track: "w-14 h-7.5",
      thumb: "w-6.5 h-6.5",
      translate: "translate-x-6.5",
      text: "text-base",
    },
  };

  const currentSize = sizes[size] || sizes.md;

  const renderLabel = () => {
    if (!label && !description) return null;

    return (
      <div className="flex flex-col select-none cursor-pointer">
        {label && (
          <span
            className={`text-sm font-semibold text-gray-800 capitalize ${currentSize.text} ${labelClassName}`}
          >
            {label}
          </span>
        )}
        {description && (
          <span className="text-xs text-gray-400 mt-0.5">{description}</span>
        )}
      </div>
    );
  };

  const renderToggle = () => (
    <div className="relative inline-flex items-center flex-shrink-0">
      {/* Hidden checkbox for form and screen reader support */}
      <input
        type="checkbox"
        id={switchId}
        checked={value}
        onChange={onChange}
        disabled={disabled}
        className="sr-only peer"
      />

      {/* Switch Track */}
      <div
        className={`relative inline-flex items-center rounded-full transition-colors duration-200 ease-in-out cursor-pointer p-0.5 ${
          currentSize.track
        } ${
          value
            ? "bg-primary border-primary"
            : "bg-gray-200 border-gray-200 hover:bg-gray-300"
        } ${
          disabled
            ? "opacity-50 cursor-not-allowed bg-gray-100"
            : "peer-focus-visible:ring-2 peer-focus-visible:ring-indigo-500/30 peer-focus-visible:ring-offset-2"
        }`}
      >
        {/* Switch Thumb */}
        <span
          className={`pointer-events-none inline-block rounded-full bg-white shadow-xs ring-0 transition-transform duration-200 ease-in-out ${
            currentSize.thumb
          } ${value ? currentSize.translate : "translate-x-0"}`}
        />
      </div>
    </div>
  );

  return (
    <label
      htmlFor={switchId}
      className={`group flex ${
        labelPosition === "top"
          ? "flex-col items-start gap-1.5"
          : labelPosition === "right"
            ? "flex-row-reverse justify-end items-center gap-3"
            : "flex-row items-center gap-3"
      } ${disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"} ${className}`}
    >
      {renderLabel()}
      {renderToggle()}
    </label>
  );
};

export default SwitchView;
